import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  OutlinedInput,
  Checkbox,
  ListItemText,
  Typography
} from "@mui/material";
import styles from "./Filter.module.css";

const Filter = ({ onApply, availableProjects = [] }) => {
  const [localFrom, setLocalFrom] = useState("");
  const [localTo, setLocalTo] = useState("");
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [isApplyDisabled, setIsApplyDisabled] = useState(false);

  const handleSubmit = () => {
    const filteredProjects =
      selectedProjects.length > 0 ? selectedProjects : availableProjects;

    onApply(localFrom || null, localTo || null, filteredProjects);
    setIsApplyDisabled(true);
    setTimeout(() => {
      setIsApplyDisabled(false);
    }, 2000);
  };

  const handleClear = () => {
    setLocalFrom("");
    setLocalTo("");
    setSelectedProjects([]);
    onApply(null, null, availableProjects);
  };

  const isFilterActive = localFrom || localTo || selectedProjects.length > 0;

  return (
    <Box className={styles.filterBox}>
      <Typography variant="h6" gutterBottom>
        Apply Filters :
      </Typography>
      <TextField
        label="From Date"
        type="date"
        value={localFrom}
        onChange={(e) => setLocalFrom(e.target.value)}
        InputLabelProps={{ shrink: true }}
        className={styles.dateField}
      />
      <TextField
        label="To Date"
        type="date"
        value={localTo}
        onChange={(e) => setLocalTo(e.target.value)}
        InputLabelProps={{ shrink: true }}
        className={styles.dateField}
      />

      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel id="project-select-label">Select Projects</InputLabel>
        <Select
          multiple
          value={selectedProjects}
          onChange={(e) => setSelectedProjects(e.target.value)}
          input={<OutlinedInput label="Select Projects" />}
          labelId="project-select-label"
          renderValue={() => ""}
        >
          {availableProjects.map((projId) => (
            <MenuItem key={projId} value={projId}>
              <Checkbox checked={selectedProjects.includes(projId)} />
              <ListItemText primary={projId} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={!isFilterActive || isApplyDisabled}
        className={styles.applyButton}
      >
        Apply Filter
      </Button>

      <Button
        variant="outlined"
        color="secondary"
        onClick={handleClear}
        disabled={!isFilterActive}
        className={styles.clearButton}
      >
        Clear Filter
      </Button>
    </Box>
  );
};

export default Filter;
